import FormGroupView from './src/formGroupView.vue';

/* istanbul ignore next */
FormGroupView.install = function(Vue) {
    Vue.component(FormGroupView.name, FormGroupView);
};

export default FormGroupView;